import { render, staticRenderFns } from "./blindOrderDetail.vue?vue&type=template&id=f53aa4fa&scoped=true"
import script from "./blindOrderDetail.vue?vue&type=script&lang=js"
export * from "./blindOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./blindOrderDetail.vue?vue&type=style&index=0&id=f53aa4fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53aa4fa",
  null
  
)

export default component.exports